import AppHeader from "../Components/AppHeader";
import Footer from "../Components/Footer";
import React from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useAuthUser } from "../../Context/AuthUserContext";
import { getPublicQrScanLocation, hasQrLinkParams } from "../../Business/CamiCodeScanBusiness";

function AppLayout() {
  const location = useLocation();
  const { authReady, isLoggedIn } = useAuthUser();

  if (!authReady) {
    return <Box sx={{ display: 'flex', marginTop: 25, marginBottom: 25, width: '100%' }}><CircularProgress sx={{ margin: '0 auto' }} /></Box >;
  }

  if (!isLoggedIn) {
    // External QR links often open `/` or another AppLayout route. Sending
    // guests to /login drops ?c=&p= / encoded tokens. Forward to the public
    // scan handler instead; non-QR visits still go to login.
    if (hasQrLinkParams(location)) {
      return <Navigate to={getPublicQrScanLocation(location)} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return (
    <section style={{ flex: 1, minHeight: "100dvh", display: "flex", flexDirection: "column", backgroundColor: "#F8F6F2" }}>
      <AppHeader />
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
        <Outlet />
      </div>
      <Footer />
    </section>
  );
}
export default AppLayout;
